import FinanceKeyObject from "../finance-product-objects/finance-key-object";
import CodeweaversResponse from "../codeweavers-response";

/**
 * Class representing a NewVehicle
 */
export default class {
    constructor(target) {
        this.target = target;
        this.id = 0;
        this.retailPrice = 0;
        this.price = 0;
        this.quoteValidDate = '';
        this.brand = '';
        this.manufacturer = '';
        this.carOrLCV = 'Car';
        this.registrationDate = '';
        this.codeweaversResponse = null;
        this.businessOnly = false;

        this.loadData();
    }

    /**
     * Get the ID of the vehicle
     *
     * @returns int
     */
    getId() {
        return this.id;
    }

    /**
     * Get an attribute from this.target
     * @param {string} attributeName
     * @param {*} defaultValue
     */
    getAttribute(attributeName = '', defaultValue = '') {
        if (!this.target.dataset[attributeName]) {
            return defaultValue;
        }
        return this.target.dataset[attributeName];
    }

    /**
     * Grabs the vehicle details from data attributes on the target
     */
    loadData() {
        this.id = this.getAttribute('id', 0);
        this.retailPrice = this.getAttribute('retail', 0);
        this.price = parseFloat(this.getAttribute('price', 0));
        this.quoteValidDate = this.getAttribute('quoteValidDate', '');
        this.brand = this.getAttribute('brand', '');
        this.manufacturer = this.getAttribute('manufacturer', '');
        this.identifier = this.getAttribute('identifier', '');
        this.identifierType = this.getAttribute('identifierType', '');
        this.carOrLCV = this.getAttribute('type', '');
        this.registrationDate = this.getAttribute('quoteValidDate', '');
        if (this.getAttribute('businessOnly', '') == 'true') {
            this.businessOnly = true;
        }
    }

    /**
     * Get the price of the vehicle based on the finance product
     * @param {FinanceKeyObject} financeKeyObject
     */
    getPriceForFinanceKeyObject(financeKeyObject) {
        if (!financeKeyObject instanceof FinanceKeyObject) {
            return this.price;
        }
        const lowerKeyName = financeKeyObject.pseudoKey.toLowerCase();
        const priceForKey = this.getAttribute('price_' + lowerKeyName, false);
        if (priceForKey == false) {
            return this.price;
        }

        return parseFloat(priceForKey);
    }

    /**
     * Get the Key + OverrideFinanceParameters for a Codeweavers request based on a FinanceKeyObject
     * @param {FinanceKeyObject} financeKeyObject
     */
    getDepositContributionWithKey(financeKeyObject) {
        let productKey = {
            "Key": financeKeyObject.key,
        };

        // const depConForKey = this.getDepositContribution(financeKeyObject);
        // if (depConForKey !== false) {
        //     productKey = { ...productKey, ...{
        //         "OverrideFinanceParameters": {
        //             "DepositContributionsOverride":[
        //             {
        //                 "Name": "Dealer Contribution",
        //                 "Value": parseFloat(depConForKey),
        //                 "Type": "Dealer",
        //                 "Uncapped": true,
        //             }]
        //         }
        //     }};
        // }

        return productKey
    }

    /**
     * Get the object which can be used to call the Codeweavers v2 finance API
     * @param {FinanceKeyObject} financeKeyObject
     */
    getCodeweaversRequestObject(financeKeyObject) {
        return {
            "Id": this.id,
            "Vehicle":{
                "CashPrice": this.getPriceForFinanceKeyObject(financeKeyObject),
                "RegistrationDate": this.registrationDate,
                "IsNew": true,
                "Identifier": this.identifier,
                "IdentifierType": this.identifierType,
                "Type": this.carOrLCV,
                "ImageUrl": '',
                "DealerVehicleUrl": window.location.href,
            },
            "Products":[
                this.getDepositContributionWithKey(financeKeyObject)
            ]
        }
    }

    /**
     * Get the object which can be used to call the Codeweavers finance parameters API
     * @param {FinanceKeyObject} financeKeyObject
     */
    getCodeweaversParameterRequestObject(financeKeyObject) {
        return {
            "OnTheRoadPrice": this.price,
            "IsNew": true,
            "Identifier": this.identifier,
            "IdentifierType": this.identifierType,
            "Type": this.carOrLCV,
        }
    }

    setCodeweaversResponse(codeweaversResponse) {
        if (!codeweaversResponse instanceof CodeweaversResponse) {
            throw new Error("setCodeweaversResponse expects an instance of CodeweaversResponse");
        }
        this.codeweaversResponse = codeweaversResponse;
    }

    brandName() {
        if (this.manufacturer == 'peugeot') {
            return 'Peugeot';
        }
        if (this.manufacturer == 'citroen') {
            return 'Citroen';
        }
        if (this.manufacturer == 'vauxhall') {
            return 'Vauxhall';
        }
        if (this.manufacturer == 'ds') {
            return 'DS';
        }
        if (this.manufacturer == 'ds automobiles') {
            return 'DS';
        }
        if (this.manufacturer == 'fiat') {
            return 'Fiat';
        }
        if (this.manufacturer == 'abarth') {
            return 'Abarth';
        }
        return 'Stellantis &You UK';
    }
}


// WEBPACK FOOTER //
// ./resources/assets/js/new-car-pages/modules/finance/vehicle-objects/new-vehicle-object.js